// owned
// eslint-disable-next-line no-unused-vars
import Logger from '../logger.js'
// eslint-disable-next-line no-unused-vars
import { Level, assertLevel } from '../log-level.js'
import LogFactory from '../log-factory.js'
import ConsoleLogger from './console-logger.js'
import LogConfig from '../log-config.js'

/**
 * Use Console as the native library
 */
export default class ConsoleLogFactory extends LogFactory {
  /**
   * the underlying "Console" Object.
   * @returns {{}}
   */
  get console () {
    return this._libraryModule // it's the embedded "console" object
  }

  /**
   * Gets the current logging settings
   * @returns {{level:number}} The logging settings object containing the current log level.
   */
  get setting () {
    if (this._setting == null) {
      this._setting = {
        level: LogConfig.currentLevel
      }
    }
    // @ts-ignore
    return this._setting
  }

  /**
   * Update factory's Log Level
   * 1. Only Provider knows how to update
   * @param {number} level - The log level to set, see {@link LogLevel.Level}
   * @returns {void}
   * @throws {Error} Throws an error as this method is Not Impled Yet.
   * @abstract
   */
  setLevel (level) {
    assertLevel(level)
    if (level !== this.setting.level) {
      this.setting.level = level
    }
    // init again
    this.init()
  }

  /**
   * Initializes the log4js provider by configuring it with the provided settings.
   * @async
   * @override
   * @returns {Promise<void>|void}
   */
  init () {
    // do nothing
  }

  /**
   * Creates a new logger instance with the specified name and log level.
   * @param {string} loggerName - The name of the logger to create.
   * @returns {Logger} A new logger instance configured with the given name and level.
   * @override
   */
  createLogger (loggerName) {
    return new ConsoleLogger(loggerName, this.console, this.setting.level)
  }
}
